<footer class="app-footer">
    <span class="footer-copyright">© 2026 Veralora</span>
    <nav class="footer-links" aria-label="Footer links">
        <a routerLink="/cookie-policy" matButton class="footer-link">Cookies</a>
        <span class="footer-separator" aria-hidden="true">|</span>
        <a routerLink="/privacy-policy" class="footer-link" matButton>Privacy</a>
        <span class="footer-separator" aria-hidden="true">|</span>
        <a routerLink="/terms-conditions" class="footer-link" matButton>Terms</a>
    </nav>
</footer>